import { render } from "./ModalNuovaNotaSpesa.vue?vue&type=template&id=76c51a60&scoped=true"
import script from "./ModalNuovaNotaSpesa.vue?vue&type=script&lang=js"
export * from "./ModalNuovaNotaSpesa.vue?vue&type=script&lang=js"

import "./ModalNuovaNotaSpesa.vue?vue&type=style&index=0&id=76c51a60&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_confcooperative/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c51a60"]])

export default __exports__